<kendo-textbox
  [placeholder]="placeholder() | translate"
  [class]="boxClass()"
  [value]="query()"
  (valueChange)="onQueryChange($event)"
  (focus)="query().trim().length ? open() : null"
  (keydown)="onKeydown($event)"
>
  <ng-template kendoPrefixTemplate>
    <span><i class="rc-icon-search fs-24 fc-neutral-800"></i></span>
  </ng-template>
  <ng-template kendoSuffixTemplate>
    @if (query()) {
      <button type="button" class="kendo-input-icon search-box__clear" [attr.aria-label]="'CLEAR_SEARCH' | translate | capitalize" (click)="clear()">
        <i class="rc-icon-times"></i>
      </button>
    }
  </ng-template>
</kendo-textbox>

@if (isOpen() && state().status !== 'idle') {
  @if (inlineResults()) {
    <ng-container [ngTemplateOutlet]="results" />
  } @else {
    <kendo-popup
      [anchor]="anchor()"
      positionMode="fixed"
      popupClass="search-box__popup" [margin]="{ horizontal: 0, vertical: 4 }">
      <ng-container [ngTemplateOutlet]="results" />
    </kendo-popup>
  }
}

<ng-template #results>
  <div
    class="search-box__results"
    [class.search-box__results--inline]="inlineResults()"
    [style.width.px]="inlineResults() ? null : popupWidth()">
    @if (canSearchEverywhere()) {
      <!-- The user's search types narrow the search: one click searches every type instead, and back -->
      <div class="search-box__scope">
        <span>{{ (everywhere() ? "SEARCHING_EVERYWHERE" : "SEARCHING_IN_YOUR_SEARCH_TYPES") | translate | capitalize }}</span>
        <button
          type="button"
          class="search-box__pill"
          [class.search-box__pill--active]="everywhere()"
          [attr.aria-pressed]="everywhere()"
          (click)="toggleEverywhere()"
        >
          @if (everywhere()) {
            <i class="rc-icon-times"></i>
            {{ "ONLY_YOUR_SEARCH_TYPES" | translate | capitalize }}
          } @else {
            <i class="rc-icon-search"></i>
            {{ "SEARCH_EVERYWHERE" | translate | capitalize }}
          }
        </button>
      </div>
    }
    <div class="search-box__list" role="listbox">
      @switch (state().status) {
        @case ('loading') {
          <p class="search-box__message">{{ "LOADING" | translate | capitalize }}...</p>
        }
        @case ('error') {
          <p class="search-box__message">{{ "SEARCH_FAILED" | translate | capitalize }}</p>
        }
        @default {
          @for (hit of hits(); track hit.id; let i = $index) {
            @let type = hitTypes()[hit.type]!;
            <button
              type="button"
              role="option"
              class="search-box__hit"
              [class.search-box__hit--active]="i === activeIndex()"
              [attr.aria-selected]="i === activeIndex()"
              (mouseenter)="activeIndex.set(i)"
              (click)="openHit(hit)"
            >
              <i class="search-box__hit-icon" [class]="type.icon"></i>
              <span class="search-box__hit-text">
                <span class="search-box__hit-title">
                  @if (hit.number && !hit.title?.includes(hit.number)) {
                    <span class="fw-600">{{ hit.number }}</span>
                  }
                  @if (hit.reference) {
                    <span class="search-box__hit-reference">{{ hit.reference }}</span>
                  }
                  @if (hit.title) {
                    <span>{{ hit.title }}</span>
                  }
                </span>
                @if (hit.subtitle) {
                  <span class="search-box__hit-subtitle">{{ hit.subtitle }}</span>
                }
              </span>
              <span class="search-box__hit-meta">
                <span>{{ type.label | translate | capitalize }}</span>
                @if (hit.date && type.showsDate) {
                  <span>{{ hit.date | kendoDate: "dd/MM/yyyy" }}</span>
                }
              </span>
            </button>
          } @empty {
            <p class="search-box__message">{{ "NO_SEARCH_RESULTS" | translate: { query: query().trim() } | capitalize }}</p>
          }
        }
      }
    </div>
  </div>
</ng-template>
